// CaregiversEngageSection.js
import React from 'react';
import { ArrowRight } from 'lucide-react';
import caregiversEngageImage from '../assets/caregivers-engage-image.jpg';

const activities = [
  'Meal preparation with a focus on nutrition',
  'Crafts, scrapbooking, and games for mental stimulation',
  'Outings together to encourage human connection',
  'Sharing life experiences while reminiscing about past events',
];

const CaregiversEngageSection = () => {
  return (
    <section className="bg-white overflow-hidden">
      {/* Calm cream intro band */}
      <div className="bg-bnCream">
        <div className="max-w-4xl mx-auto px-6 text-center py-20 md:py-28">
          <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-6">
            B &amp; N Enterprise Home Care
          </p>
          <h2 className="font-display font-light text-bnInk leading-snug text-3xl md:text-4xl lg:text-[2.9rem] mb-6">
            Proudly Caring for Canberra's Seniors, One Home at a Time
          </h2>
          <p className="text-bnBody text-base leading-relaxed max-w-2xl mx-auto">
            At B &amp; N Enterprise, we believe every older person deserves to feel valued, respected, and supported in the place they call home. Our carers provide personalised support that encourages safety, independence, and companionship, helping families across Canberra find peace of mind while their loved ones live life to the fullest.
          </p>
        </div>
      </div>

      {/* Image and content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div className="relative">
            <img
              src={caregiversEngageImage}
              alt="A carer with an older woman using a tablet"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl mb-6">
              Our Carers Engage Seniors in Their Day-to-Day Activities
            </h3>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-8 max-w-lg">
              <p>
                We take great care in matching each client with a carer who not only has the right skills but also a compatible personality. A strong, trusting relationship is the foundation of quality companion care, and we are committed to finding the right fit for your family. Our goal is to provide a companion who feels like a natural extension of your family.
              </p>
              <p>
                To set your mind at ease, B &amp; N Enterprise is a fully licensed and insured provider, and every carer is thoroughly screened before they join us. We take the time to match your loved one with a warm companion who suits their personality and interests, and who will encourage them in healthy activities such as:
              </p>
            </div>

            <ul className="space-y-5">
              {activities.map((activity) => (
                <li key={activity} className="flex items-start gap-4">
                  <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full border border-bnAccent text-bnAccent">
                    <ArrowRight size={16} />
                  </span>
                  <span className="text-bnInk text-base leading-relaxed">{activity}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaregiversEngageSection;
